// ----------------------------------------------------------------------------
// Template: Product
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/cart-confirmation/cart-confirmation';
import 'snippets/_containers/swatches/swatches';
import 'snippets/specs-table/specs-table';
import 'snippets/product-form/product-form';
import 'snippets/product-zoom/product-zoom';
import 'snippets/product-sfp-zoom/product-sfp-zoom';
import 'blocks/media-gallery';
import 'blocks/collapsible-content';
import 'blocks/subscription-options';
import 'sections/featured-collection/featured-collection';
import 'sections/pdp-content-panel/pdp-content-panel';
import 'sections/compare-block/compare-block';
import 'sections/collapsible-content/collapsible-content';
import 'sections/faqs/faqs';
import 'sections/ingredients/ingredients';
import 'sections/progress-bar/progress-bar';
import 'sections/bought-together/bought-together';
import 'sections/usp-banner/usp-banner';
import 'sections/tabbed-cards/tabbed-cards';
import 'sections/card-flip/card-flip';
import 'sections/day-night-pack-split/day-night-pack-split';
import 'sections/app-wrapper/app-wrapper';
import 'sections/bundle-cards/bundle-cards';
import 'sections/testimonial/testimonial';
import 'sections/guarantee-bar/guarantee-bar';
import 'sections/rich-text/rich-text';
import 'sections/main-product/main-product';
import 'sections/main-product-v2/main-product-v2';
import 'sections/sticky-add-to-cart/sticky-add-to-cart';
import 'sections/main-bundle-product/main-bundle-product';
import 'sections/product-recommendations/product-recommendations';
import 'sections/bv-reviews/bv-reviews';
import 'sections/logo-list/logo-list';

// -------------------------------------
// Hooks
// -------------------------------------
// Section bootstrapping: `load('*')` runs once from `assets/scripts/app.js`